// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"206":"edb3b64d","587":"6373403c","848":"05f44e2c"}[chunkId] + ".js";
};